import { cn } from '@/lib/utils';
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  variant?: 'solid' | 'outline';
  size?: 'lg' | 'md';
  className?: string;
};
export function CtaButton({
  children,
  href = '#planes',
  variant = 'solid',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const base = 'display group inline-flex w-full items-center justify-center gap-3 rounded-none border-2 text-center transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950';
  const sizes = size === 'lg' ? 'px-7 py-5 text-xl sm:text-2xl' : 'px-5 py-4 text-lg';
  const variants = variant === 'solid' ? 'border-bone bg-bone text-ink-950 hover:bg-ice hover:border-ice' : 'border-ink-700 bg-transparent text-bone hover:border-bone hover:bg-bone hover:text-ink-950';
  return <motion.a href={href} whileHover={{
    y: -2
  }} whileTap={{
    y: 0,
    scale: 0.99
  }} transition={{
    type: 'spring',
    stiffness: 500,
    damping: 30
  }} className={cn(`${base} ${sizes} ${variants} ${className}`, "bg-[#ECECEC]")} data-id="element-208" data-mp="2hgkxfznk4pjj">
      <span className="text-[#090909]" data-id="element-209" data-mp="2qg7zmno41zdn">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-210" data-mp="2lierhp38yvaq" />
    </motion.a>;
}